/// <amd-module name="VSS/Features/PlatformUI/Components/FPSLink/FPSLink" />
import * as React from "react";

import { onClickFPS } from "VSS/Platform/FPS";
import { VssComponent } from "VSS/Platform/Layout";
import { IVssTelemetryService } from "VSS/Platform/Telemetry";

import { Link } from "VSSUI/Link";

import { IFPSLinkProps } from "./FPSLink.Props";

export class FPSLink extends VssComponent<IFPSLinkProps> {
    public render(): JSX.Element {
        const linkProps = {
            ...this.props,
            onClick: this.onClick
        };

        return <Link {...linkProps} />;
    }

    private onClick = (event: React.MouseEvent<HTMLAnchorElement> | React.KeyboardEvent<HTMLAnchorElement>) => {
        this.props.onClick && this.props.onClick(event);

        if (!event.isDefaultPrevented()) {
            if (this.props.href && this.props.supportsFPS !== false) {
                onClickFPS(this.context.pageContext, this.props.href, true, event, {
                    telemetrySource: this.props.telemetrySource,
                    telemetryProperties: this.props.telemetryProperties,
                    navigationId: this.props.navigationId
                });
            } else if (this.props.telemetrySource) {
                const telemetryService = this.context.pageContext.getService<IVssTelemetryService>("IVssTelemetryService");
                telemetryService.publishEvent("WebPlatform", "Link", {
                    ...(this.props.telemetryProperties || {}),
                    source: this.props.telemetrySource
                });
            }
        }
    };
}
